import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      version='1.1'
      viewBox='0 0 32 32'
    >
      <path d='M4 3c-.6 0-1 .4-1 1v7h2V5h6V3H4zm17 0v2h6v6h2V4c0-.6-.4-1-1-1h-7zM3 21v7c0 .6.4 1 1 1h7v-2H5v-6H3zm24 0v6h-6v2h7c.6 0 1-.4 1-1v-7h-2z'></path>
    </svg>
  );
}

export default Icon;
